import React from 'react';
import { useContext, createContext, useEffect, useState, useMemo } from 'react'
import { UserContext } from './UserContext'
import api from '../services/api';

const UCMSContext = createContext();

const UCMSProvider = ({children}) => {
    const context = useContext(UserContext);
    const [ucms, setUcms] = useState([]);
    const [ucmSelected, setUcmSelected] = useState(null);
    

    
    useEffect(()=>{
      if(context.token && context.user){
        getNewUcms()
      }
    },[ context.token])

    async function getNewUcms(){
      try {
        const results = await Promise.all(
          context.user.ucm.map(id => api.post("/ucms/byId", { id }))
        )
        setUcms(results.map(r => r.data))
      } catch (err) {
        console.error('Erro ao carregar UCMs:', err)
      }
    }
    const value = useMemo(() => ({ ucms, ucmSelected, setUcmSelected }), [ucms, ucmSelected])

    return (
      <UCMSContext.Provider value={value}>
        {children}
      </UCMSContext.Provider>
    );
}

export { UCMSContext, UCMSProvider };